// Consent gate (CRM 2.0 M3-F11, DC-169 / DC-170). The server decides which terms a portal action needs,
// sends and checks the OTP, and saves the acceptance. Backend: routes/consentGate.js.
import axios from "axios";
import { portalHeaders, unwrapOtp } from "./ServerOtp";

const apiUrl = `${process.env.REACT_APP_PAYMENT_LINK_URL}consent`;

// → { items: [{ termId, title, content, version, how: TICK|TICK_OTP, who, applicantId?, signer?, askId? }], blocked, hasTerms }
export const getPendingConsent = (point, allotmentPaymentId) =>
	unwrapOtp(axios.get(`${apiUrl}/pending`, { params: { point, ...(allotmentPaymentId ? { allotmentPaymentId } : {}) }, headers: portalHeaders() }));
export const sendConsentOtp = (body) => unwrapOtp(axios.post(`${apiUrl}/otp`, body, { headers: portalHeaders() }));
export const acceptConsent = (body) => unwrapOtp(axios.post(`${apiUrl}/accept`, body, { headers: portalHeaders() }));
